export const SignInUsernameParameter = "username";
export const SignInMethodParameter = "method";
